// extracted by mini-css-extract-plugin
module.exports = {"box_one":"style_box_one__31KH5","box_two":"style_box_two__2by4J","box_three":"style_box_three__1ZKP3"};